export default class extends HTMLElement {
  connectedCallback () {
    this.select = this.querySelector('select')
    this.smtpFields = document.getElementById('smtp_fields')
    this.resendFields = document.getElementById('resend_fields')

    this.select.addEventListener('change', () => this.toggle())
  }

  toggle () {
    if (this.select.value === 'resend') {
      this.smtpFields.classList.add('hidden')
      this.resendFields.classList.remove('hidden')
    } else {
      this.smtpFields.classList.remove('hidden')
      this.resendFields.classList.add('hidden')
    }
  }
}
